import { render, staticRenderFns } from "./nftMarket.vue?vue&type=template&id=1f3691e9&scoped=true&"
import script from "./nftMarket.vue?vue&type=script&lang=js&"
export * from "./nftMarket.vue?vue&type=script&lang=js&"
import style0 from "./nftMarket.vue?vue&type=style&index=0&id=1f3691e9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3691e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f3691e9')) {
      api.createRecord('1f3691e9', component.options)
    } else {
      api.reload('1f3691e9', component.options)
    }
    module.hot.accept("./nftMarket.vue?vue&type=template&id=1f3691e9&scoped=true&", function () {
      api.rerender('1f3691e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customChildren/nftMarket.vue"
export default component.exports